import React, { useEffect, useRef, useState } from "react";
import { useI18n } from "../providers/I18nProvider";
import "../styles/RejectLeaveDialog.css";

// window.prompt yerine: "İptal" izni reddetmez, Esc ile kapanır, işlem sırasında tekrar tıklanamaz.
const RejectLeaveDialog = ({ leave, onConfirm, onClose }) => {
  const { t } = useI18n();
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    const onKey = (e) => {
      if (e.key === "Escape" && !busy) onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [busy, onClose]);

  if (!leave) return null;

  const submit = async () => {
    if (busy) return;
    setBusy(true);
    try {
      await onConfirm(leave.id, reason.trim() || null);
    } finally {
      setBusy(false);
      onClose();
    }
  };

  return (
    <div className="reject-backdrop" onMouseDown={() => !busy && onClose()}>
      <div
        className="reject-dialog"
        role="dialog"
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <h3>{t("admin.leaves.rejectTitle")}</h3>
        <p className="reject-sub">
          {leave.user_name} {leave.user_surname} · {leave.leave_type_name} ·{" "}
          {String(leave.start_date).slice(0, 10)} – {String(leave.end_date).slice(0, 10)}
        </p>
        <label>
          {t("admin.leaves.rejectPrompt")}
          <textarea
            ref={inputRef}
            rows={3}
            maxLength={500}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </label>
        <div className="reject-actions">
          <button type="button" className="btn" onClick={onClose} disabled={busy}>
            {t("common.cancel")}
          </button>
          <button type="button" className="btn btn-reject" onClick={submit} disabled={busy}>
            {t("admin.leaves.reject")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectLeaveDialog;
